import { render, staticRenderFns } from "./sizeForm.vue?vue&type=template&id=0895a48e&scoped=true&lang=pug"
import script from "./sizeForm.vue?vue&type=script&lang=js"
export * from "./sizeForm.vue?vue&type=script&lang=js"
import style0 from "./sizeForm.vue?vue&type=style&index=0&id=0895a48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895a48e",
  null
  
)

export default component.exports